import { defineStore } from 'pinia';
import { ref} from 'vue';

export const useEnergyConfirmationStore = defineStore('energy-confirmation', () => {
    const displayModal = ref(false)
    const confirmationCallback = ref(null)
    const cost = ref(null)
    const title = ref(null)
    function setConfirmationCallback(callback) {
        confirmationCallback.value = callback
    }
    function clearEnergyData() {
        displayModal.value = false
        confirmationCallback.value = null
        cost.value = null
        title.value = null
    }
    return { displayModal, cost, title ,confirmationCallback, setConfirmationCallback, clearEnergyData}
});
